import { IStep } from "../../../../classes/interfaces";

export function stepSubtitle(step: IStep): string {
  if (step.minimum === 1 && step.maximum === 1) return "Selecione 1 item";
  if (step.minimum > 0 && step.maximum > 0) return `Selecione de ${step.minimum} até ${step.maximum} itens`;
  if (step.maximum > 0) return `Selecione até ${step.maximum}`;
  return "Selecione à vontade";
}
